import React, { useState, ChangeEvent } from "react";
import { IntlShape } from "react-intl";

import { CoverImageUploader } from "src/app/components/CoverImageUploader/CoverImageUploader";
import CustomInput, {
  CustomInputLabel,
} from "src/app/components/CustomInput/CustomInput";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import { translateMessage } from "src/app/methods/translateMessage";
import FormSection from "./FormSection";

interface GeneralSectionProps {
  coverImageFile: File | null;
  setNewImage: (file: File | null) => void;
  intl: IntlShape;
  projectName: string;
  onChangeProjectName: (e: ChangeEvent<HTMLInputElement>) => void;
}

export default function GeneralSection({
  coverImageFile,
  setNewImage,
  intl,
  projectName,
  onChangeProjectName,
}: GeneralSectionProps) {
  const [showUploadLogoModal, setShowUploadLogoModal] =
    useState<boolean>(false);

  const getCoverImageUrl = () => {
    let coverImageUrl = null;
    if (coverImageFile) {
      coverImageUrl = URL.createObjectURL(coverImageFile);
    } else {
      coverImageUrl = null;
    }

    return coverImageUrl;
  };
  const coverImageUrl = getCoverImageUrl();

  return (
    <>
      <FormSection
        title={<IDHFormattedMessage id="ws_general" defaultMessage="General" />}
        dataQa="cover-image-uploader"
      >
        <CustomInputLabel>
          <IDHFormattedMessage
            id="ws_cover_photo"
            defaultMessage="Cover photo"
          />
        </CustomInputLabel>
        <CoverImageUploader
          showUploadLogoModal={showUploadLogoModal}
          uploadFunction={setNewImage}
          openModal={() => setShowUploadLogoModal(true)}
          closeModal={() => setShowUploadLogoModal(false)}
          coverImageUrl={coverImageUrl}
          removeImage={() => {
            setNewImage(null);
          }}
        />
      </FormSection>
      <FormSection dataQa="project-name-input">
        <CustomInputLabel htmlFor="projectName" required>
          <IDHFormattedMessage id="ws_campaign_name" defaultMessage="Name" />
        </CustomInputLabel>
        <CustomInput
          id="projectName"
          type="text"
          value={projectName}
          onChange={onChangeProjectName}
          placeholder={translateMessage({
            intl,
            id: "ws_type_campaign_name",
            defaultMessage: "Type campaign name",
          })}
          fullWidth
        />
      </FormSection>
    </>
  );
}
